import { bustedReload as e, noteBootRecovery as t } from "@maat/store-error";
//#region src/staleChunk/reloadForStaleChunk.ts
var n = "maat.staleChunkReloadAt", r = 2e4;
function i(i = "stale-chunk", a) {
	if (typeof window > "u") return !1;
	let o;
	try {
		o = window.sessionStorage;
	} catch {
		o = void 0;
	}
	if (o) {
		let e = Date.now(), t = Number(o.getItem(n) ?? "0");
		if (Number.isFinite(t) && e - t < r) return !1;
		try {
			o.setItem(n, String(e));
		} catch {}
	}
	return t(i, a), e(), !0;
}
//#endregion
export { i as reloadForStaleChunk };
